import { render, staticRenderFns } from "./NuevosIngresosTabContent.vue?vue&type=template&id=cafca828"
import script from "./NuevosIngresosTabContent.vue?vue&type=script&lang=js"
export * from "./NuevosIngresosTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports